import React from 'react';
import styled from 'styled-components';

const Spinner = styled.div`
  width: 0%;
  left: 0;
  height: 2px;
  background-color: white;
  position: absolute;
  animation: 2s linear line infinite;
`
const Wrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  heigt: 100%;
`

const Loading = ({ loading }) => {
  if (loading) {
    return (
      <Wrapper>
        <Spinner />
      </Wrapper>
    )
  }
  return null
};

export default Loading;